import { ExplorableItemType } from '~src/spacesPlatform/models/ContentType';
import { IContent } from '~src/spacesPlatform/models/IContent';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { IUserInfo } from '../../../userManagement/users/models/IUserInfo';
import { ISharedWithMeCustomViewInfo } from '../../models/ISharedWithMeContentInfo';

export interface IShareAction {
  id: string;
  contentId: number;
  contentType: ExplorableItemType;
  createdAt: string;
  isSharerDeleted: boolean;
  message: string;
  sharerId: number;
  underhoodCustomizedViewId?: string;
}

// getSharedWithMe API response interface
export interface IGetSharedWithMeResult extends IGetItemsResult {
  content: IContent[];
  deletedSharers: IUserInfo[];
  owners: IUserInfo[];
  sharers: IUserInfo[];
  shareActions: IShareAction[];
  viewsWithShareActivity: number[];
  underhoodCustomizedViews: ISharedWithMeCustomViewInfo[];
}

export class GetSharedWithMeRequest extends Request<IGetItemsParams, IGetSharedWithMeResult> {
  constructor(params: IGetItemsParams) {
    super('getSharedWithMe', params);
  }
}
